import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { KTSVG } from '../../../../_metronic/helpers/components/KTSVG';
import './QRScanSection.css';

interface Props {
  qrValue: string;
}

const QRScanSection: React.FC<Props> = ({ qrValue }) => {
  return (
    <div className="qrs-card">
      {/* Phone icon + label */}
      <div className="qrs-top-badge">
        <KTSVG path="/media/icons/duotune/general/gen009.svg" className="svg-icon-5 me-1" />
        Scan instantly with your phone
      </div>

      {/* QR code */}
      <div className="qrs-qr-box">
        <QRCodeSVG
          value={qrValue}
          size={150}
          bgColor="#ffffff"
          fgColor="#0f3460"
          level="M"
          includeMargin={false}
        />
      </div>

      {/* Instruction */}
      <p className="qrs-instruction-text">
        Open your phone camera and point it at the QR code above
        for <strong>the best scan results</strong>.
      </p>
    </div>
  );
};

export default QRScanSection;
